<template>
  <vs-row vs-justify="center" vs-align="center" class="full-height login-register-bg">
    <vs-col type="flex" vs-justify="center" vs-align="center" class="login-register-box" vs-lg="12" vs-xs="12">
      <img class="logo-cliente" src="@/assets/images/logo/Accesspark_logo_square_txt.png" alt=""/>
      <vs-card class="mb-0" style="padding-top: 50px; border-radius: 5%">
        <form @submit="checkForm" novalidate="true">
          <div slot="header">
            <vs-row>
              <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
                <h2 class="mb-4 justify-content-center"> {{ msg }}</h2>
              </vs-col>
            </vs-row>
          </div>
          <vs-row class="justify-content-center">
            <vs-alert
                v-if="errorsInfo.length"
                class="mb-2 mt-1" color="danger"
            >
              <b>Por favor corrige el siguiente error:</b>
              <ul
                  class="common-list">
                <li
                    v-for="error in errorsInfo"
                    :key="error">
                  {{ error }}
                </li>
              </ul>
            </vs-alert>
            <InputPassword
                icon-after="true"
                size="large"
                class="w-100 mb-2 vs-input-large"
                type="pass_new"
                icon="lock"
                label-placeholder="Ingrese su contraseña"
                v-model="pass_new"/>

            <InputPassword
                icon-after="true"
                size="large"
                class="w-100 mb-2 mt-2 vs-input-large"
                type="pass_new"
                icon="lock"
                label-placeholder="Ingrese su confirmación de contraseña"
                v-model="pass_nowconfirm"/>

            <PasswordStrengthMeter :password="pass_new" :confirmPassword="pass_nowconfirm"  @validation-change="passwordChange" :language="$i18n.locale" />


            <button
                class="btn-block btn btn-with-loader btn-primary submit-button mt-3"
                type="submit"
                :loading="loading"
                :disabled="!passwordIsValid || loading"
            >
                <span class="spin-loader" v-if="loading"></span>
                <span v-if="!loading">
                  Asignar nueva contraseña
                </span>
            </button>
          </vs-row>
        </form>
        <div class="d-flex justify-content-center mt-3">
          <router-link
              to="/view/login">Volver a inicio de sesión
          </router-link>
        </div>
        <!-- linea de credenciales beta -->
        <hr class="custom-hr"/>
        <div class="mt-1 text-center">
          <b>Power by</b>
          <a style=" text-decoration: none; color: black;" href="https://www.accesspark.co">
            Accesspark.co
          </a>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>
<script>
import md5 from "md5";
import globalEndpoint from "@/endpoints/core/GlobalEndpoint";
import InputPassword from '../../components/Shared/InputPassword'
import PasswordStrengthMeter from '../../components/Shared/PasswordStrengthMeter/PasswordStrengthMeter.vue'
import ToastConfig from '@/global/ToastConfig';

export default {
  components: {
    InputPassword,
    PasswordStrengthMeter,
  },
  data: () => ({
    msg: "Ingrese su nueva contraseña",
    loading: false,
    identification: "",
    errorsInfo: [],
    name: "Login",
    pass_new: "",
    pass_nowconfirm: "",
    passwordIsValid: false,
  }),
  computed: {},
  mounted(){
    ToastConfig.init({context: this})
  },
  methods: {
    passwordChange({ isValid }) {
      this.passwordIsValid = isValid
    },
    checkForm: function (e) {
      if (!this.passwordIsValid) {
        return
      }

      this.errorsInfo = [];
      if (!this.pass_new) {
        this.errorsInfo.push("Digite contraseña ");
      }
      if (this.pass_nowconfirm === "") {
        this.errorsInfo.push("Digite contraseña de confirmación ");
      }
      if (this.pass_new !== this.pass_nowconfirm) {
        this.errorsInfo.push("las contraseñas no coinciden.");
      }
      e.preventDefault();
      if (!this.errorsInfo.length) {
        const secretAccess = localStorage.getItem("access");
        const pwd = md5(this.pass_new);
        this.loading = true;
        globalEndpoint.editPassword(pwd, secretAccess)
            .then(result => {
              console.log("el resultado =========>>  ", result);
              if (result.code >= 1) {
                this.$router.push("/view/login");
              }
            })
            .finally(() => {
              this.loading = false;
            });
        return true;
      }
      return false;
    }
  },

};

</script>
<style>
.login-register-bg {
  margin: 0 auto;
  background: url(../../assets/images/background/lancaster_1080_1-100.jpg) no-repeat fixed center center;
  background-size: cover;
}

.login-register-box {
  max-width: 400px;
}

.logo-cliente {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  box-shadow: 2px 2px 10px #3d3d3d44;
  position: relative;
  bottom: -50px;
  left: 35%;
}

.logo-grafico {
  background-color: white;
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.logo-historia {
  width: 100px;
  height: 100px;
  border-radius: 30%;
  box-shadow: 2px 2px 10px #3d3d3d44;
  background-color: white;
  float: right;
}

.button-container {
  height: 47.89px !important;
}
</style>
